export const brandConfig = {
  name:        'DCCO E-Learning',
  shortName:   'DCCO',
  tagline:     'تعلّم المهارات التقنية بمحتوى عربي احترافي',
  logo:        '/assets/images/logo/logo-main.svg',
  logoWhite:   '/assets/images/logo/logo-white.svg',
  logoIcon:    '/assets/images/logo/logo-icon.svg',
  primaryColor:   '1 47 51',
  secondaryColor: '78 167 153',
  accentColor:    '245 166 35',
  contact: {
    email:    'support@dcco.sa',
    phone:    '+966 XX XXX XXXX',
    website:  'https://dcco.sa',
  },
  social: {
    twitter:  'https://twitter.com/dcco_sa',
    linkedin: 'https://linkedin.com/company/dcco-sa',
  },

  // Current authenticated user role: 'student' | 'instructor' | 'admin'
  // Backend overrides this at runtime via applyBrandConfig({ role: 'instructor' })
  role: 'student',

  // Feature flags — set to false to hide UI sections for this tenant
  features: {
    'social-login':  true,   // Google / Apple / Twitter / LinkedIn login buttons
    'live-sessions': true,   // Live video sessions
    'community':     true,   // Forum, groups, peer review
    'certificates':  true,   // Certificates and achievements
    'leaderboard':   true,   // Gamification leaderboard
    'referrals':     true,   // Referral program
    'payments':      true,   // Paid course enrollment
  },
};

export function applyBrandConfig(config = brandConfig) {
  Object.assign(brandConfig, config);

  const root = document.documentElement;
  if (config.primaryColor)   root.style.setProperty('--dcco-primary',   config.primaryColor);
  if (config.secondaryColor) root.style.setProperty('--dcco-secondary', config.secondaryColor);
  if (config.accentColor)    root.style.setProperty('--dcco-accent',    config.accentColor);
  if (config.tenant)         root.dataset.tenant = config.tenant;

  document.querySelectorAll('[data-brand-name]').forEach(el => {
    el.textContent = brandConfig.name;
  });
  document.querySelectorAll('[data-brand-tagline]').forEach(el => {
    el.textContent = brandConfig.tagline;
  });
  document.querySelectorAll('[data-brand-logo]').forEach(el => {
    el.src = brandConfig.logo;
    el.alt = brandConfig.shortName;
  });
  document.querySelectorAll('[data-brand-logo-white]').forEach(el => {
    el.src = brandConfig.logoWhite;
    el.alt = brandConfig.shortName;
  });
  document.querySelectorAll('[data-brand-logo-icon]').forEach(el => {
    el.src = brandConfig.logoIcon;
    el.alt = brandConfig.shortName;
  });
}
